export default __webpack_public_path__ + "static/media/check-box-min.712f25b3.png";